import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ width = '100%', height = 500 }) => (
  <div style={{ maxWidth: '577px', margin: '0 auto' }}>
    <ContentLoader
      speed={2}
      style={{ width, height }}
      primarycolor="#f3f3f3"
      secondarycolor="#ecebeb"
    >
      <rect x="0" y="40" rx="6" ry="6" width="30%" height="20" />

      <rect x="0" y="80" rx="6" ry="6" width="20%" height="15" />
      <rect x="0" y="100" rx="6" ry="6" width="100%" height="10" />
      <rect x="0" y="120" rx="6" ry="6" width="100%" height="10" />
      <rect x="0" y="140" rx="6" ry="6" width="70%" height="10" />

      <rect x="0" y="160" rx="6" ry="6" width="20%" height="15" />
      <rect x="0" y="180" rx="6" ry="6" width="80%" height="10" />
      <rect x="0" y="200" rx="6" ry="6" width="90%" height="10" />
      <rect x="0" y="220" rx="6" ry="6" width="40%" height="10" />

      <rect x="0" y="250" rx="6" ry="6" width="100%" height="40" />
      <rect x="0" y="300" rx="6" ry="6" width="100%" height="40" />
      <rect x="0" y="350" rx="6" ry="6" width="100%" height="40" />
    </ContentLoader>
  </div>
);

export default Loader;
